import { useEffect, useState } from "react";

// Breakpoints matching Tailwind: sm=640px, xl=1280px
const SM_BREAKPOINT = 640;
const XL_BREAKPOINT = 1280;

/**
 * Track responsive column count based on viewport width.
 * Returns 1, 2, or 3 columns matching Tailwind grid-cols breakpoints.
 */
export function useColumns(): number {
  const [columns, setColumns] = useState(() => {
    if (typeof window === "undefined") {
      return 1;
    }
    const width = window.innerWidth;
    if (width >= XL_BREAKPOINT) {
      return 3;
    }
    if (width >= SM_BREAKPOINT) {
      return 2;
    }
    return 1;
  });

  useEffect(() => {
    const updateColumns = () => {
      const width = window.innerWidth;
      if (width >= XL_BREAKPOINT) {
        setColumns(3);
      } else if (width >= SM_BREAKPOINT) {
        setColumns(2);
      } else {
        setColumns(1);
      }
    };

    // Update columns immediately on mount to handle SSR hydration
    updateColumns();

    window.addEventListener("resize", updateColumns);
    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  return columns;
}
